
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, PageOptions } from 'cw-backend';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';
import { Delivery } from '../../../../../models/attendance/delivery';

@Injectable()
export class DeliveryListProvider implements Resolve<any> {
    delivery: Delivery[];
    deliveryEdit: Delivery;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.deliveryEdit = this.state?.currentDelivery;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
            this.pageOptions.fieldSort = 'forecast_at';
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'forecast_at';
        }
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    get(id: number): Observable<Delivery> {
        if (!id) {
            return null;
        }
        return this.gw.get('delivery/:id', { id: id });
    }

    get currentDelivery(): Delivery {
        return this.deliveryEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('delivery/').subscribe({
                next: (res: HttpResponse<any>) => {
                    this.delivery = res.body;
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });

    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('delivery/search', pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    if (!CwUtils.compare(this.delivery, res.body.content) && res.body.content.length > 0) {
                        this.delivery = res.body.content;
                        this.onDataChanged.next(this.delivery);
                    }
                    else {
                        this.delivery = res.body.content;
                    };
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

